import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { LabModel } from '../../../common/viewModels/Admin/LabModel';
import { PagerService } from '../../../common/pagerService';
import { AmplifyService } from '../../../common/amplify-service';

@Component({
  selector: 'lablist',
  templateUrl: './lablist.component.html',
  styleUrls: ['./lablist.component.scss']
})

export class LabList implements OnInit {
  id: number;
  pager: any = {};
  pagedItems: any[];
  isNoRecords: boolean = true;
  labSearchForm: FormGroup;
  searchFields: LabModel = new LabModel();
  length: number = 0;
  isShow: boolean = false;
  labDto: LabModel[];
  mainComponent: any;
  pageSize: number = 10;

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _pageSrvc: PagerService,
    private _toastrService: ToastrService, private _amplifyService: AmplifyService
  ) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageSize = this.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
    this.CreateForm();
    this.BindStaticSearchData();
    this.GetDataFromAmpliy();
    this.setPage(this.pager);
    this.ClearDataInAmplify();
  }

  CreateForm() {
    this.labSearchForm = this._formBuilder.group({
      Name: [''],
    })
  }

  GetLabDetails(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetLabDetails + id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          if (data.json() != null) {
            this.isShow = true;
            this.labDto = (data.json().Result);
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  onSubmit() {
    this.pager.pageIndex = 0;
    this.ConstructSearchData();
    this.setPage(this.pager);
  }

  ConstructSearchData() {
    let searchDto = this.labSearchForm.value;
    this.searchFields.Name = searchDto.Name;
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pageSrvc.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetLabList(this.pager);
  }

  GetLabList(page: any) {
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetLabList, this.searchFields)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          if (data.json() != null) {
            var data = data.json();
            this.pagedItems = data.Result;
            this.length = data.PageResult.TotalRecords;
            this.pagedItems = data.Result;
            this.isNoRecords = !(data.Result.length > 0);
            this._mApp.HideLoader();
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

  DeleteLab(id: number) {
    this.id = id;
  }

  DeleteLabById(id: number) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteLab + id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
          this._toastrService.success(data.json().Result);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

  OnReset() {
    this.labSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.CreateForm();
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }

  SaveDataInAmplify() {
    this._amplifyService.SetStorage('labList', this.labSearchForm.value);
    this._amplifyService.SetStorage('labList_PageNo', this.pager.pageIndex);
    this._amplifyService.SetStorage('labList_PageSize', this.pager.pageSize);
  }


  GetDataFromAmpliy() {
    let storedData = this._amplifyService.GetStorage('labList');
    if (storedData != undefined && storedData != null) {
      this.labSearchForm.setValue(storedData);
      this.ConstructSearchData();
    }
    // let savedPageSize = this._amplifyService.GetStorage('labList_PageSize');
    // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pageSrvc.pageSize;
    let pageIndex = this._amplifyService.GetStorage('labList_PageNo');
    if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
      this.pager.pageIndex = pageIndex;
    else
      this.pager.pageIndex = 0;
  }

  ClearDataInAmplify() {
    this._amplifyService.ClearStorage('labList');
    this._amplifyService.ClearStorage('labList_PageNo');
    this._amplifyService.ClearStorage('labList_PageSize');
  }
}
